import React, { useEffect, useRef, useState } from "react";
import PolarImage from "./PolarImage";
import LikertImage from "./LikertImage";
import AnsweringPageFooter from "../../SharedComponents/AnswerIngPageFooter";
import FinishingModal from "../../SharedComponents/FinishingModal";
import "animate.css";
import { ExitFullscreen } from "../../../../Helpers/FullscreenHelper";
import { useNavigate } from "react-router-dom";

export function PolarLikertSlider(props) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  let percentage = (window.questionNo / props.questions.length) * 100 + "%";

  const [current, setCurret] = useState();
  const [maxQuestionNumber, setMaxQuestionNumber] = useState(0);
  const [finishModalShow, setFinishModalShow] = useState(false);

  const imageRef = useRef();
  let AnswerinFooterNextButtonProps = {
    func: null,
    text: null,
    isDisabled: null,
  };

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const GetDifferences = (questionNo) => {
    const prevQuestion = props.questions.find((x) => x.order === questionNo - 1);
    const currentQuestion = props.questions.find((x) => x.order === questionNo);
    const nextQuestion = props.questions.find((x) => x.order === questionNo + 1);

    const getType = (q) => (q?.subPolaredId || q?.polaredId ? "polar" : "likert");

    const prevType = getType(prevQuestion);
    const currentType = getType(currentQuestion);
    const nextType = getType(nextQuestion);

    let differences = { isDifferentThanPrevious: false, isDifferentThanNext: false, currentType: currentType };

    // Going back from current to previous
    if (prevType !== currentType) {
      differences = { ...differences, isDifferentThanPrevious: true }; // or any other you want
    }

    // Going forward from current to next
    if (nextType !== currentType) {
      differences = { ...differences, isDifferentThanNext: true }; // or any other you want
    }

    differences = { ...differences, questionNumber: questionNo };
    return differences; // return empty string if no animation
  };

  const NextQuestion = async () => {
    const nextQuestionNo = window.questionNo + 1;
    if (nextQuestionNo > props.questions.length) {
      setFinishModalShow(true);
      return;
    }
    const differences = GetDifferences(window.questionNo);

    await imageRef.current.ExitAnimation("next", differences.isDifferentThanNext, differences.isDifferentThanPrevious); //goingTo, isNextDifferent, isPreviousDifferent

    renderQuestion(nextQuestionNo);
  };

  const PrevQuestion = async () => {
    const prevQuestionNo = window.questionNo - 1;
    if (prevQuestionNo === 0) {
      // props.goBack();
      return;
    }

    const differences = GetDifferences(window.questionNo);
    if (window.questionNo <= maxQuestionNumber && prevQuestionNo >= maxQuestionNumber - 1) {
      await imageRef.current.ExitAnimation(
        "previous",
        differences.isDifferentThanNext,
        differences.isDifferentThanPrevious
      ); //goingTo, isNextDifferent, isPreviousDifferent

      renderQuestion(prevQuestionNo, true);
    }
  };

  const HandleEntryAnimation = (goToPrev) => {
    const currentQuestion = props.questions.find((x) => x.order === window.questionNo);

    let textEntryAnimation = "temp";
    let answersEntryAnimation = "temp";

    if (currentQuestion?.subLikertId || currentQuestion?.likertId) {
      if (goToPrev) {
        // to previous likert

        textEntryAnimation = "animate__backInLeft";
      } else {
        // to next likert

        textEntryAnimation = "animate__backInRight";
      }
    }

    if (currentQuestion?.subPolaredId || currentQuestion?.polaredId) {
      answersEntryAnimation = "animate__fadeInUp";
    }

    const differences = GetDifferences(window.questionNo);

    if (goToPrev) {
      if (differences.isDifferentThanPrevious) {
        // if type is switching
        textEntryAnimation = "animate__fadeInDown";
        answersEntryAnimation = "animate__fadeInUp";
      }
    } else {
      if (differences.isDifferentThanNext) {
        textEntryAnimation = "animate__fadeInDown";
        answersEntryAnimation = "animate__fadeInUp";
      }
    }

    return { textEntryAnimation, answersEntryAnimation };
  };

  let Finish = () => {
    props.finish(props.questions);
    setFinishModalShow(false);
  };

  let DismisFinish = () => {
    props.dismissFinish(props.questions);
    setFinishModalShow(false);
  };

  let SetAnswer = async (order, option, nextQuestionNo, isPolar, timer) => {
    //if (window.innerWidth <= 500 || isPolar) setIsOverlayVisible(true);

    props.questions.map((q) => {
      if (q.order === order) {
        q.answer = option;
        if (q.timer) q.timer = q.timer + timer;
        else q.timer = timer;
      }
    });
    props.isB2b && props.update(props.questions);
    // if (window.innerWidth <= 500 || isPolar) await timeout(200);
    //if (window.innerWidth <= 500 || isPolar) setIsOverlayVisible(false);

    if (window.lastAnswerNo < nextQuestionNo) {
      window.lastAnswerNo = nextQuestionNo - 1;
    }

    await NextQuestion();
  };

  let renderQuestion = (n, goToPrev) => {
    if (n === 1 && !goToPrev) {
      //uygulama onceden baslami mi kontrol ediliyor, baslamis ise kalinan sira bulunuyor
      let startedBefore = props.questions.find((x) => {
        return x.answer !== undefined;
      });

      let last = props.questions.find((x) => {
        return x.answer === undefined;
      });

      if (last) n = last.order;
      if (!Boolean(startedBefore)) {
        window.lastAnswerNo = 0;
      } else if (!last && startedBefore) {
        n = props.questions.length;
      }
    }
    if (maxQuestionNumber < n) setMaxQuestionNumber(n);
    const image = props.questions.find((x) => x.order === n);
    const entryAnimations = HandleEntryAnimation(goToPrev);

    window.questionNo = n;

    if (image.subLikertId || image.likertId) {
      setCurret(
        <LikertImage
          ref={imageRef}
          key={n}
          q={image}
          a={props.answers}
          n={n}
          SetAnswer={SetAnswer}
          isLastQuestion={window.questionNo + 1 > props.questions.length}
          textEntryAnimation={entryAnimations.textEntryAnimation}
          answersEntryAnimation={entryAnimations.answersEntryAnimation}
        />
      );
    } else if (image.subPolaredId || image.polaredId) {
      setCurret(
        <PolarImage
          ref={imageRef}
          key={n}
          q={image}
          n={n}
          SetAnswer={SetAnswer}
          isLastQuestion={window.questionNo + 1 > props.questions.length}
          textEntryAnimation={entryAnimations.textEntryAnimation}
          answersEntryAnimation={entryAnimations.answersEntryAnimation}
        />
      );
    }
  };

  let HandleNextButtonFunctionAndText = () => {
    if (window.questionNo === props.questions.length) {
      AnswerinFooterNextButtonProps = {
        func: () => {
          props.HandleFinishButton();
          navigate("/userDash");
          ExitFullscreen();
        },
        text: "Uygulamayı Bitir",
      };
    } else {
      AnswerinFooterNextButtonProps = {
        func: NextQuestion,
        text: "Sonraki",
      };
    }
  };

  /*let CloseApplication = async () => {
    setIsOverlayVisible(true);
    await timeout(400);          todo: remove if safe
    window.close();
  };*/

  HandleNextButtonFunctionAndText();

  return (
    <>
      <FinishingModal show={finishModalShow} Finish={Finish} DismisFinish={DismisFinish} />

      <h4 className="header-question-no animate__animated  animate__fadeInDown">
        {window.questionNo} / {props.questions.length}
      </h4>
      <div className="header-progress bar-container w-100">
        <div className="bar animate__animated  animate__backInLeft" style={{ width: percentage }}></div>
      </div>
      <div className="animate__animated  animate__fadeInDown">
        {!current && props.questions && renderQuestion(1)}
        {current}
      </div>
      <div>
        <AnsweringPageFooter
          prevButtonFunction={PrevQuestion}
          prevButtonText="Önceki"
          nextButtonText={AnswerinFooterNextButtonProps.text}
          nextButtonFunction={AnswerinFooterNextButtonProps.func}
          isNextDisabled={props.isTest ? false : props.isFinished ? false : window.lastAnswerNo < window.questionNo}
          isPrevDisabled={
            !(window.questionNo <= maxQuestionNumber && window.questionNo > maxQuestionNumber - 1) ||
            window.questionNo === 1
          }
          hideSaveAndQuit={props.isFinished}
        />
      </div>
    </>
  );
}
